module.exports = __webpack_public_path__ + "static/loosechange-2-7a65f49b08474e14c9819c51f298b7fe.png";